<template>
  <Background :theme="theme?.background">
    <CompactPadding :padding="theme?.padding">
      <slot />
    </CompactPadding>
  </Background>
</template>

<script lang="ts" setup>
import Background from '~/components/Atoms/Background/Background.vue';
import CompactPadding from '~/components/Atoms/CompactPadding/CompactPadding.vue';
import type { BlockTheme } from '~/sanity/types';
defineProps<{ theme?: BlockTheme }>();
</script>

<style></style>
